export default {
  'categories.shoes': 'Zapatos',
  'categories.hoodies': 'Sudaderas / Suéteres',
  'categories.tshirts': 'Camisetas',
  'categories.jackets': 'Chaquetas',
  'categories.pants': 'Pantalones / Shorts',
  'categories.headwear': 'Gorras y sombreros',
  'categories.sets': 'Conjuntos',
  'categories.underwear': 'Ropa interior',
  'categories.jersey': 'Camisetas deportivas',
  'categories.accessories': 'Accesorios',
  'categories.bags': 'Bolsos',
  'categories.belts': 'Cinturones',
  'categories.perfumes': 'Perfumes',
  'categories.other': 'Otras cosas',
};